<template>
  <div class="pc-footer-wrap" id="pcFooter">
    <ul>
      <li
        v-for="item in liDataFirst"
        :key="item.name"
        @click="handleItemClick(item)"
      >
        {{ item.name }}
      </li>
      <li>
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002002297"
          rel="noreferrer"
          target="_blank"
        >
          <img src="../assets/wangan_ico.png" />粤公网安备44030002002297
        </a>
      </li>
      <li
        v-for="item in liData"
        :key="item.name"
        @click="handleItemClick(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from "vue";
// import { useRouter } from "vue-router";
// const router = useRouter();
const liDataFirst = ref([
  {
    name: "Copyright © 2003-2024 学而思 xueersi.com 深圳市可乐堂教育咨询有限公司 版权所有",
    link: "",
  },
  {
    name: "粤ICP备2021146510号-4",
    link: "https://beian.miit.gov.cn/#/Integrated/index",
  },
]);
const liData = ref([
  {
    name: `地址：深圳市福田区华强北街道福强社区红荔路2001号四川大厦1层1号、14层1402号`,
    link: "",
  },
  {
    name: "电话：10101985",
    link: "",
  },
]);
const handleItemClick = (item) => {
  if (item.link) {
    window.open(item.link);
  }
};
</script>
<script>
export default {
  name: "pcFooter",
};
</script>
<style scoped lang="less">
.pc-footer-wrap {
  min-height: 56px;
  padding: 14px;
  width: 1200px;
  line-height: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  border-top: 0.5px solid rgba(229, 229, 229, 1);
  background: #f7f7fa;
  ul {
    display: flex;
    align-items: center;
    margin: 0 auto;
    justify-content: center;
    flex-wrap: wrap;
    li {
      list-style: none;
      cursor: pointer;
      color: #6e6e73;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      & + li {
        margin-left: 16px;
      }
      a {
        display: block;
        color: #6e6e73;
        text-decoration: none;
        img {
          vertical-align: text-bottom;
          margin-right: 6px;
        }
      }
    }
    li:nth-child(2) {
      margin-left: 5px !important;
    }
  }
}
</style>
